module.exports = __webpack_public_path__ + "img/waist.2bdadd7c.png";